import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { CustomQuestionsQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/QuestionnaireSectionProps";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";

import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";

import * as questionIds from "../consultationQuestions/questionIds";
import { sections } from "../consultation";

// eslint-disable-next-line max-len
const HealthSurveillanceConsultationMsdAssessmentSectionUnconnected: React.FunctionComponent<CustomQuestionsQuestionnaireSectionProps> = (props: CustomQuestionsQuestionnaireSectionProps) => {
    const questions = Object.values(props.questions || {});
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.MsdAssessment}
        >
            {YesNoWithFollowUpQuestion({
                readonly: props.readonly,
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.MsdAssessmentUnableToCarryOut),
                    getQuestionConfig(props.questionConfigs, questionIds.MsdAssessmentUnableToCarryOutReason)
                ],
                mandatory: true,
                followUpMandatory: true,
                questions: props.questions
            })}
            {getAnswerToQuestionWithId(questions, questionIds.MsdAssessmentUnableToCarryOut) !== MultiButtonQuestion.YesOption && <>
                <p>Locomotor System - Can patient demonstrate full movement of the following?</p>
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DemonstratedFullMovementOfNeck)}
                    mandatory
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DemonstratedFullMovementOfBack)}
                    mandatory
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DemonstratedFullMovementOfLeftShoulder)}
                    mandatory
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DemonstratedFullMovementOfLeftElbow)}
                    mandatory
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DemonstratedFullMovementOfRightShoulder)}
                    mandatory
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DemonstratedFullMovementOfRightElbow)}
                    mandatory
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DemonstratedFullMovementOfLeftWrist)}
                    mandatory
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DemonstratedFullMovementOfLeftLeg)}
                    mandatory
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DemonstratedFullMovementOfRightWrist)}
                    mandatory
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DemonstratedFullMovementOfRightLeg)}
                    mandatory
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DoRestrictionsAffectPerformance)}
                    mandatory
                />
                <TextQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DoRestrictionsAffectPerformanceNotes)}
                    mandatory
                    multiline
                />
            </>}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceConsultationMsdAssessmentSection = connect(makeMapStateToQuestionnaireSectionProps(sections.MsdAssessment.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceConsultationMsdAssessmentSectionUnconnected);
